window.AccountMessage = (function () {
    const selectors = {
        LIST_ITEM: ".infocenter-messagelist__list-item",
        M_COLLAPSE_BUTTON: ".infocenter-messagelist__message-collapse-button",
        M_ITEMS_BODY: ".infocenter-messagelist__items-body",
        M_MESSAGE_ROW: "#message-row-"
    }
    return {
        readMessage: function (id) {
            $(selectors.LIST_ITEM).removeClass('m-active');
            $("#message-container-" + id).addClass("m-active");
            var readed = "<div>" + window.Localization.getString('Scripts_Shared_Modules.AccountMessage_18', 'Прочитано') + "</div>";
            $("#message-status-" + id).replaceWith(readed);
        },
        readMessageMobile: function (id) {

            $(selectors.M_MESSAGE_ROW + id + " a").on('click', function (e) {
                e.stopPropagation();
            });

            var isExpanded = $(selectors.M_MESSAGE_ROW + id).hasClass("expanded");

            $(selectors.LIST_ITEM).removeClass("expanded");
            $(selectors.M_COLLAPSE_BUTTON).removeClass("expanded");
            $(selectors.M_ITEMS_BODY).removeClass("expanded");

            if (!isExpanded) {
                $(selectors.M_MESSAGE_ROW + id).addClass("expanded");
                $(selectors.M_MESSAGE_ROW + id + " " + selectors.M_COLLAPSE_BUTTON).addClass("expanded");
                $(selectors.M_MESSAGE_ROW + id + " " + selectors.M_ITEMS_BODY).addClass("expanded");
            }
            var readedMobile = "<div>" + window.Localization.getString('Scripts_Shared_Modules.AccountMessage_18', 'Прочитано') + "</div>";
            $(selectors.M_MESSAGE_ROW + id + " " + ".infocenter-messagelist__list-item-status-new").replaceWith(readedMobile);
        }
    };
}());